<template>
  <div class="cs-root">
    <div class="cs-wrapper" :class="{ mini: collapsed }">
      <!-- 左侧功能栏 -->
      <aside class="cs-sidebar">
        <div class="cs-brand">
          <div class="cs-brand-logo">客</div>
          <div class="cs-brand-text">客服工作台</div>
        </div>

        <nav class="cs-nav">
          <div class="cs-nav-group-title">业务办理</div>
          <div
            v-for="item in menu"
            :key="item.key"
            class="cs-nav-item"
            :class="{ active: $route.path === item.path }"
            @click="go(item.path)"
          >
            <i class="fa" :class="item.icon"></i><span>{{ item.title }}</span>
          </div>
        </nav>

        <div class="cs-sidebar-foot">
          <div class="cs-logout" @click="onLogout">
            <i class="fa fa-sign-out"></i><span>退出登录</span>
          </div>
        </div>
      </aside>

      <!-- 右侧信息操作区 -->
      <section class="cs-main">
        <header class="cs-topbar">
          <button class="cs-collapse" @click="collapsed = !collapsed"><i class="fa fa-bars"></i></button>
          <div class="cs-page-title">{{ pageTitle }}</div>
          <div class="cs-topbar-right">
            <div class="cs-avatar">{{ avatarText }}</div>
            <div class="cs-user-name">{{ displayName }}</div>
          </div>
        </header>

        <div class="cs-content">
          <router-view />
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { authApi } from '../api/cs'

// 当前仅一个功能：自动择日提交信息；后续新增功能直接往 MENU 里加。
const MENU = [
  { key: 'selectionOrders', title: '自动择日提交信息', icon: 'fa-calendar-check-o', path: '/cs/selection-orders' }
]

export default {
  name: 'CsLayout',
  data () {
    return {
      collapsed: false,
      menu: MENU
    }
  },
  computed: {
    profile () {
      return authApi.profile()
    },
    displayName () {
      return this.profile ? (this.profile.display_name || this.profile.login_name || '客服') : '客服'
    },
    avatarText () {
      const n = this.displayName || '客服'
      return n.slice(0, 1).toUpperCase()
    },
    pageTitle () {
      const t = this.$route.meta && this.$route.meta.title
      return t || '客服工作台'
    }
  },
  methods: {
    go (path) {
      if (this.$route.path !== path) this.$router.push(path)
    },
    onLogout () {
      authApi.logout()
      this.$router.replace('/cs/login')
    }
  }
}
</script>

<style lang="scss">
@import url('/admin/font-awesome/css/font-awesome.min.css');
@import '../styles/cs-theme.scss';
</style>
